export const legalFormStep7FieldNames = {
  FORM_TYPE: "formType",
  SMS_SERVICE: "smsService",
  INTERNET_BANK: "internetBank",
  CURRENCY: "currency",
  STREET: "street",
  CARD_INFO: "cardInfo",
  // CARD_INFO_MAIN_CURRENCY: 'mainCurrency',
  // CARD_INFO_CURRENCY: 'cardInfoCurrency',
  // CARD_INFO_DELIVERY_METHOD: 'deliveryMethod',
  CARD_INFO_BRANCH_ID: "branchId",
  CARD_INFO_DELIVERY_ADDRESS: "deliveryAddress",
  CARD_INFO_DELIVERY_CITY: "deliveryCity",
  CARD_INFO_DELIVERY_STREET: "deliveryStreet",
  CARD_INFO_DELIVERY_HOME_NUMBER: "deliveryHomeNumber",
  CARD_INFO_DELIVERY_APARTMENT_NUMBER: "deliveryApartmentNumber",
};

export const LEGAL_CERVICES = (t, isGeoLang) => [
  {
    value: 3,
    label: t("service_packages"),
    // redirectURL: isGeoLang
    //   ? 'https://procreditbank.ge/ge/tables/%E1%83%A2%E1%83%90%E1%83%A0%E1%83%98%E1%83%A4%E1%83%94%E1%83%91%E1%83%98?mid=923'
    //   : 'https://procreditbank.ge/en/tables/service-fees-1',
    // checked: false,
  },
  {
    value: 4,
    label: t("service_full_packages"),
    // redirectURL: isGeoLang
    //   ? 'https://procreditbank.ge/ge/tables/%E1%83%A2%E1%83%90%E1%83%A0%E1%83%98%E1%83%A4%E1%83%94%E1%83%91%E1%83%98?mid=923'
    //   : 'https://procreditbank.ge/en/tables/service-fees-1',
    // checked: false,
  },
];
